import * as $ from 'jquery';

function initSections() {

  const widgets = document.querySelectorAll(".widgets");

  for (let i = 0; i < widgets.length; i++) {

    let innerContentIsHidden = false;
    let innerContent = widgets[i].children[0] as HTMLElement;
    if(innerContent != null && innerContent != undefined)
    {
          innerContentIsHidden = innerContent.classList.contains('d-none');
    }
    if (widgets[i].innerHTML.replace(/^\s*/, "").replace(/\s*$/, "") == "" || innerContentIsHidden) {

      widgets[i].classList.add('empty');

    } else {

      let innerWidgets = Array.from(widgets[i].getElementsByClassName('widget-content'));
      if (innerWidgets.length > 0) {
        let isEmpty = !innerWidgets.find(c => c.innerHTML.replace(/^\s*/, "").replace(/\s*$/, "") != "");
        if (isEmpty) {

          widgets[i].classList.add('empty');

        }
      }
    }

  }
}

export { initSections };